import clsx from "classnames";
import { Carousel, Col, Container, Row, Stack } from "react-bootstrap";
import { chunk } from "lodash";
import classes from "./styles.module.scss";
import ChevronRight from "@/assets/ChevronRight.svg";
import ChevronLeft from "@/assets/ChevronLeft.svg";
import { JobCard, Title } from "@/ui";
import { getRoute } from "@/getters/getRoute";
import { useState } from "react";
import { jobs_helper } from "@/helpers/jobs_helper";

export default function LatestJobs({
  sectionId,
  className,
  bgColor,
  title,
  titleColor,
  jobTitle = "",
  sector = null,
  employer = null,
  visibleCount,
}) {
  const [items] = useState(() =>
    jobs_helper.fetch({
      jobTitle,
      sector,
      employer, 
      limit: 20,
    }),
  );

  return (
    <div id={sectionId} className={clsx(className, bgColor, classes.jobs)}>
      <Container className="mw-xxl">
        {title && (
          <Stack className="flex-md-row justify-content-between mb-4">
            <Title title={title} className={clsx(titleColor, "mb-md-0 text-center text-md-start")} />
          </Stack>
        )}
        {items.length > 0 ? (
          <Carousel
            id="jobs"
            controls={items.length > visibleCount}
            indicators={false}
            prevIcon={<ChevronLeft width="14" height="25" />}
            nextIcon={<ChevronRight width="14" height="25" />}
          >
            {chunk(items, visibleCount).map((items, k) => (
              <Carousel.Item key={k}>
                <Row>
                  {items.map((job, k) => (
                    <Col key={k} xs={12} md={12 / visibleCount} className="mb-4">
                      <JobCard className="bg-light h-100" {...job} />
                    </Col>
                  ))}
                </Row>
              </Carousel.Item>
            ))}
          </Carousel>
        ) : (
          <span>Sorry there are no live jobs at the moment.</span>
        )}
        <div className={classes.jobs__footer}>
          <a className={classes.jobs__link} href={getRoute("jobs")}>
            View more jobs
            <ChevronRight width="7" height="13" className="ms-2" />
          </a>
        </div>
      </Container>
    </div>
  );
}
